export function getShadowProps(props) {
    var _a;
    var classes = (_a = {},
        _a['box-shadow-2'] = props['box-shadow-2'] === true && props.boxShadow != 'none',
        _a['box-shadow-1'] = props['box-shadow-1'] === true && props.boxShadow != 'none',
        _a['box-shadow-1-inset'] = props['box-shadow-1-inset'] === true && props.boxShadow != 'none',
        _a[props.boxShadow] = typeof props.boxShadow === 'string' && props.boxShadow != 'none',
        _a);
    return {
        classes: classes,
        props: {},
        styles: {},
        variables: {}
    };
}
